import {environment} from '../../environments/environment';

export const ApiConfig = {
    apiUrl: environment.apiUrl,
    uploadUrl: `${environment.apiUrl}/uploads`,
    routes: {
      login: 'authentication_token',
      refresh_token: 'api/token/refresh',
      user_profile: 'api/v1/users/{id}',
      user_config: 'api/v1/user_configs/{id}',
      user_column_config: 'api/v1/user_configs/{id}/columns',
      register: 'api/users',
      instrumento_livesearch: 'api/v1/instrumentos/search',
      options_snapshot: 'api/v1/options/snapshot',
      options: 'api/v1/options',
      options_index: 'api/v1/options/save',
      options_details: 'api/v1/options/{id}',
      instrumento_index: 'api/v1/instrumentos',
      tipo_instrumento_index: 'api/v1/tipo_instrumentos',
      tipo_operacion_index: 'api/v1/tipo_operacions',
      cartera_index: 'api/v1/carteras',
      cartera_details: 'api/v1/carteras/{id}',
      cartera_clone: 'api/v1/carteras/{id}/clone',
      sector_index: 'api/v1/sectors',
      fuente_index: 'api/v1/fuentes',
      cartera_columna_index: 'api/v1/cartera_columnas',
      operacion_columna_index: 'api/v1/operacion_columnas',
      operacion_simbolo_index: 'api/v1/simbolo_operacions',
      operacion_simbolo_index_id: 'api/v1/simbolo_operacions/{id}',
      alerts_index: 'api/v1/alerts',
      alerts_index_id: 'api/v1/alerts/{id}',
      operacion_simbolo_options: 'api/v1/simbolo_operacions/save_options',
      operacion_simbolo_file: 'api/v1/simbolo_operacions/import_simbol_file',
      export_simbolo_file: 'api/v1/simbolo_operacions/export_simbol_file',
      operacion_index: 'api/v1/operacions',
      operacion_details: 'api/v1/operacions/{id}',
      operacion_details_emit: 'api/v1/operacions/emit/{id}',
      tags_index: 'api/v1/tags',
      operacion_tags: 'api/v1/operacions/{id}/tags',
      broker_index: 'api/v1/brokers',
      tipo_vencimiento_index: 'api/v1/tipo_vencimientos'
    }
};
